import React, { useRef, useState, useEffect } from "react";

import "../styles/Header.css"
import logo_dut from "../assets/images/logo_dut.svg"
import { LuLogOut } from "react-icons/lu";
import { useMsal } from "@azure/msal-react";
import SSOService from "../services/SSOService";
import { APIStatus } from "../constants/constant";
import { adjustTextColor, getInitials, stringToColor } from "../functions/function";


const Header = (props) => {
  const { userInfo } = props;
  const [isOptionOpened, setIsOptionOpened] = useState(false);
  const optionBoxRef = useRef(null);
  const avaButtonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        optionBoxRef.current &&
        !optionBoxRef.current.contains(event.target) &&
        avaButtonRef.current &&
        !avaButtonRef.current.contains(event.target)
      ) {
        setIsOptionOpened(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  const { instance } = useMsal();
  const { postLogout } = SSOService();

  const handleLogout = async () => {
    const response = await postLogout();
    if (response.status === APIStatus.success) {
      // Pop up
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        // mainWindowRedirectUri: "/"
      });

      localStorage.removeItem("idTeamSelected");

      // Redirect
      // instance.logoutRedirect({
      //   postLogoutRedirectUri: "/",
      // });
    }
    else console.error(response.data);
  }

  return (
    <nav className="header">
      <span className="navbar-title">
        <img src={logo_dut} alt="error" />
        <span>MSTeamsTool</span>
      </span>
      <span className="navbar-user">
        <div className="name-display">
          <span>{userInfo.displayName}</span>
          <span className="email">{userInfo.mail}</span>
        </div>
        {userInfo.avatar ? (
          <img
            ref={avaButtonRef}
            src={`data:image/png;base64,${userInfo.avatar}`}
            alt="error"
            className="user-avatar"
            onClick={(e) => {
              e.stopPropagation();
              setIsOptionOpened((prev) => !prev);
            }} />
        ) : (
          <div
            ref={avaButtonRef}
            className="user-avatar"
            style={{
              backgroundColor: stringToColor(userInfo.displayName),
              color: adjustTextColor(stringToColor(userInfo.displayName))
            }}
            onClick={(e) => {
              e.stopPropagation();
              setIsOptionOpened((prev) => !prev);
            }}>{getInitials(userInfo.displayName)}</div>
        )}
        <span ref={optionBoxRef} className={`user-option ${isOptionOpened ? "active" : ""}`}>
          <button onClick={() => handleLogout()}><LuLogOut /> Sign out</button>
        </span>
      </span>
    </nav>
  );
};

export default Header;
